(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-barra-oferta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTicker() {
      var dias = ['DOMINGO', 'LUNES', 'MARTES', 'MIÉRCOLES', 'JUEVES', 'VIERNES', 'SÁBADO'];
      var hoy = dias[new Date().getDay()];
      var els = document.querySelectorAll('.lp-dia-hoy');
      for (var i = 0; i < els.length; i++) { els[i].textContent = hoy; }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initTicker); }
    else { initTicker(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-compra-reciente"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var pop = document.getElementById('lp-sp-pop');
      if (!pop || pop.dataset.init) return;
      pop.dataset.init = '1';
      if (pop.parentNode !== document.body) { document.body.appendChild(pop); }

      // Sube el popup solo cuando la barra sticky de abajo esta visible (para no taparse)
      var sticky = document.getElementById('lp-moving-bar');
      if (sticky) {
        var syncPos = function () { pop.classList.toggle('lp-sp-raised', sticky.classList.contains('visible')); };
        try { new MutationObserver(syncPos).observe(sticky, { attributes: true, attributeFilter: ['class'] }); } catch (e) {}
        syncPos();
      }

      var nameEl = document.getElementById('lp-sp-name');
      var locEl = document.getElementById('lp-sp-location');
      var timeEl = document.getElementById('lp-sp-time');
      var closeBtn = document.getElementById('lp-sp-close');
      if (!nameEl || !locEl || !timeEl) return;

      var firstDelay = (parseInt(pop.getAttribute('data-first'), 10) || 6) * 1000;
      var interval = (parseInt(pop.getAttribute('data-interval'), 10) || 14) * 1000;
      var duration = (parseInt(pop.getAttribute('data-duration'), 10) || 5) * 1000;

      var people = [
        { n: 'Sofía', p: 'Córdoba' }, { n: 'Valentina', p: 'Buenos Aires' }, { n: 'Martina', p: 'Santa Fe' },
        { n: 'Camila', p: 'Mendoza' }, { n: 'Lucía', p: 'Rosario' }, { n: 'Julieta', p: 'Tucumán' },
        { n: 'Micaela', p: 'La Plata' }, { n: 'Florencia', p: 'Mar del Plata' }, { n: 'Agustina', p: 'Salta' },
        { n: 'Carla', p: 'Neuquén' }, { n: 'Rocío', p: 'Córdoba' }, { n: 'Paula', p: 'Buenos Aires' },
        { n: 'Daniela', p: 'Santa Fe' }, { n: 'Belén', p: 'Mendoza' }, { n: 'Antonella', p: 'Entre Ríos' },
        { n: 'Ayelén', p: 'Chubut' }, { n: 'Milagros', p: 'San Juan' }, { n: 'Brenda', p: 'Buenos Aires' },
        { n: 'Melina', p: 'Córdoba' }, { n: 'Guadalupe', p: 'Corrientes' }, { n: 'Abril', p: 'Misiones' },
        { n: 'Candela', p: 'Buenos Aires' }, { n: 'Ariana', p: 'Santa Fe' }, { n: 'Malena', p: 'Río Negro' },
        { n: 'Yamila', p: 'La Rioja' }, { n: 'Noelia', p: 'San Luis' }, { n: 'Romina', p: 'Buenos Aires' },
        { n: 'Gisela', p: 'Córdoba' }, { n: 'Tamara', p: 'Santa Cruz' }, { n: 'Jazmín', p: 'Formosa' },
        { n: 'Luciana', p: 'Mendoza' }, { n: 'Aldana', p: 'Buenos Aires' }, { n: 'Ornella', p: 'Santa Fe' },
        { n: 'Bianca', p: 'Córdoba' }, { n: 'Priscila', p: 'Jujuy' }
      ];

      var closed = false;
      var i = 0;
      function shuffle() { people.sort(function () { return Math.random() - 0.5; }); }
      shuffle();

      function relTime(min) {
        if (min < 1) return ' hace unos segundos';
        if (min === 1) return ' hace 1 minuto';
        if (min < 60) return ' hace ' + min + ' minutos';
        var h = Math.floor(min / 60);
        if (h === 1) return ' hace 1 hora';
        if (h < 24) return ' hace ' + h + ' horas';
        var d = Math.floor(h / 24);
        return d === 1 ? ' ayer' : ' hace ' + d + ' días';
      }

      function show() {
        if (closed) return;
        var person = people[i];
        nameEl.textContent = person.n;
        locEl.textContent = 'Desde ' + person.p;
        var minutes = 2 + Math.floor(Math.random() * Math.random() * 178);
        timeEl.textContent = relTime(minutes);
        pop.classList.add('is-visible');
        setTimeout(function () { pop.classList.remove('is-visible'); }, duration);
        i++;
        if (i >= people.length) { i = 0; shuffle(); }
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', function () { closed = true; pop.classList.remove('is-visible'); });
      }

      setTimeout(show, firstDelay);
      setInterval(show, interval);
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
    else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-cta-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSticky() {
      try {
        var anchor = document.getElementById('lp-sticky-anchor');
        var bar = document.getElementById('lp-moving-bar');
        if (!bar || bar.dataset.init) return;
        bar.dataset.init = '1';
        if (anchor && anchor.parentNode !== document.body) { document.body.appendChild(anchor); }

        var trigger = parseInt(bar.getAttribute('data-scroll'), 10) || 1200;

        var lastY = 0;
        var scrollerInfo = 'init';
        function show(v) { if (v) { bar.classList.add('visible'); } else { bar.classList.remove('visible'); } }

        // Lee el scroll del elemento que REALMENTE se mueve (ventana O contenedor interno)
        function readY(e) {
          var el = e && e.target;
          if (el && el.nodeType === 1 && el !== document.documentElement && el !== document.body) {
            // contenedor interno: solo confiar si es un area grande (el scroll principal, no un carrusel)
            if (el.clientHeight >= window.innerHeight * 0.7) {
              scrollerInfo = (el.tagName || '?') + ' ch=' + el.clientHeight;
              return el.scrollTop;
            }
            return null; // scroller chico (carrusel, acordeon): ignorar
          }
          scrollerInfo = 'window';
          return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        }
        function onScroll(e) {
          var y = readY(e);
          if (y === null) return;
          lastY = y;
          show(y > trigger);
        }
        // Captura (true) atrapa el scroll de CUALQUIER contenedor interno; el de window cubre el caso normal
        document.addEventListener('scroll', onScroll, { passive: true, capture: true });
        window.addEventListener('scroll', onScroll, { passive: true });

        // Respaldo: buscar el contenedor de scroll y engancharle un listener directo
        try {
          var nodes = document.body.getElementsByTagName('*');
          var best = null;
          for (var i = 0; i < nodes.length; i++) {
            var n = nodes[i];
            var oy = getComputedStyle(n).overflowY;
            if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight + 100 && n.clientHeight >= window.innerHeight * 0.7) {
              if (!best || n.clientHeight > best.clientHeight) { best = n; }
            }
          }
          if (best) {
            best.addEventListener('scroll', function () { lastY = best.scrollTop; scrollerInfo = (best.tagName || '?') + ' (fijo)'; show(lastY > trigger); }, { passive: true });
          }
        } catch (e2) {}

        onScroll();

        // Reloj (cuenta regresiva visual, se reinicia)
        var clock = bar.querySelector('.lp-sticky-bar__clock');
        if (clock) {
          var parts = (clock.textContent || '10:00').split(':');
          var total = (parseInt(parts[0], 10) || 10) * 60 + (parseInt(parts[1], 10) || 0);
          var t = total;
          setInterval(function () {
            var m = Math.floor(t / 60), s = t % 60;
            clock.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
            if (--t < 0) t = total;
          }, 1000);
        }

        // Boton: limpia carrito + agrega + va al carrito
        var btn = document.getElementById('lp-sticky-btn');
        if (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var vid = btn.getAttribute('data-variant-id');
            var addUrl = btn.getAttribute('data-cart-add') || '/cart/add';
            var clearUrl = btn.getAttribute('data-cart-clear') || '/cart/clear';
            var cartUrl = btn.getAttribute('data-cart-url') || '/cart';
            var span = btn.querySelector('span');
            if (span) { span.textContent = 'PROCESANDO... ✨'; }
            btn.style.pointerEvents = 'none';
            btn.style.opacity = '0.85';
            var go = function () { window.location.href = '/checkout'; };
            fetch(clearUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
              .then(function () { return fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) }); })
              .then(go).catch(go);
          });
        }
      } catch (err) { /* nunca romper el resto de la pagina */ }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initSticky); }
    else { initSticky(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-galeria"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGal() {
      var gals = document.querySelectorAll('.lp-galeria[data-hearts="true"]');
      for (var i = 0; i < gals.length; i++) {
        (function (g) {
          if (g.dataset.hinit) return;
          g.dataset.hinit = '1';
          setInterval(function () {
            var heart = document.createElement('div');
            heart.className = 'lp-gal-heart';
            var drift = (Math.random() - 0.5) * 60;
            heart.style.setProperty('--drift', drift + 'px');
            heart.style.left = 'calc(50% + ' + ((Math.random() - 0.5) * 120) + 'px)';
            var dur = 2.5 + Math.random() * 2;
            heart.style.animation = 'lp-gal-float ' + dur + 's ease-in forwards';
            g.appendChild(heart);
            setTimeout(function () { heart.remove(); }, dur * 1000);
          }, 450);
        })(gals[i]);
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initGal); }
    else { initGal(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-oferta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function initCountdowns() {
      var nodes = document.querySelectorAll('.lp-countdown');
      for (var i = 0; i < nodes.length; i++) {
        (function (el) {
          if (el.dataset.init) return;
          el.dataset.init = '1';
          var mins = parseInt(el.getAttribute('data-minutes'), 10) || 120;
          var key = 'lp_deadline_' + (el.getAttribute('data-key') || 'default');
          var now = Date.now();
          var dl = parseInt(localStorage.getItem(key), 10);
          if (!dl || dl < now || dl > now + mins * 60000) { dl = now + mins * 60000; localStorage.setItem(key, String(dl)); }
          var hEl = el.querySelector('.lp-cd-h');
          var mEl = el.querySelector('.lp-cd-m');
          var sEl = el.querySelector('.lp-cd-s');
          function tick() {
            var diff = dl - Date.now();
            if (diff < 0) diff = 0;
            var m = Math.floor(diff / 60000);
            var s = Math.floor((diff % 60000) / 1000);
            if (mEl) mEl.textContent = pad(m);
            if (sEl) sEl.textContent = pad(s);
          }
          tick();
          setInterval(tick, 1000);
        })(nodes[i]);
      }
    }
    function initReviews() {
      var halfs = document.querySelectorAll('.lp-oferta .star-svg.half');
      for (var i = 0; i < halfs.length; i++) {
        var svg = halfs[i];
        var pct = parseInt(svg.getAttribute('data-fill') || '70', 10);
        var clip = svg.querySelector('clipPath rect');
        if (clip) clip.setAttribute('width', (24 * Math.max(0, Math.min(pct, 100)) / 100).toString());
      }
      var el = document.querySelector('.lp-oferta .lp-reviews-count');
      if (!el || el.dataset.done) return;
      el.dataset.done = '1';
      var target = parseInt(el.getAttribute('data-countup'), 10) || 0;
      var duration = 1200, t0 = null;
      function fmt(n) { try { return n.toLocaleString('es-AR'); } catch (e) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); } }
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / duration, 1);
        el.textContent = fmt(Math.floor(target * p));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    function initScarcity() {
      var vn = document.querySelector('.lp-oferta .lp-dyn-num[data-scar="viewers"]');
      var cn = document.querySelector('.lp-oferta .lp-dyn-num[data-scar="cart"]');
      if (!vn || !cn) return;
      function update(el, val) { el.classList.add('flash'); setTimeout(function () { el.textContent = val; el.classList.remove('flash'); }, 250); }
      var v = 28, c = 9;
      vn.textContent = v; cn.textContent = c;
      setInterval(function () { v += (Math.random() > 0.5 ? 2 : -1); if (v < 20 || v > 55) v = 28; update(vn, v); }, 5000);
      setInterval(function () { c += (Math.random() > 0.5 ? 1 : -1); if (c < 4 || c > 18) c = 9; update(cn, c); }, 8000);
    }
    function initCarousel() {
      var c = document.getElementById('testimonialCarousel');
      if (!c) return;
      var slides = c.querySelectorAll('.testimonial-slide');
      var dots = c.querySelectorAll('.dot');
      var prev = c.querySelector('.nav-prev');
      var next = c.querySelector('.nav-next');
      var i = 0, t;
      function show(n) {
        for (var x = 0; x < slides.length; x++) {
          slides[x].classList.toggle('active', x === n);
          slides[x].style.display = x === n ? 'flex' : 'none';
        }
        for (var d = 0; d < dots.length; d++) { dots[d].classList.toggle('active', d === n); }
        i = n; restart();
      }
      function nextSlide() { show((i + 1) % slides.length); }
      function prevSlide() { show((i - 1 + slides.length) % slides.length); }
      function start() { t = setInterval(nextSlide, 6000); }
      function stop() { clearInterval(t); }
      function restart() { stop(); start(); }
      for (var k = 0; k < dots.length; k++) {
        (function (dot) { dot.onclick = function () { show(parseInt(dot.getAttribute('data-index'), 10)); }; })(dots[k]);
      }
      if (next) next.onclick = nextSlide;
      if (prev) prev.onclick = prevSlide;
      start();
    }
    function initBuyButtons() {
      var btns = document.querySelectorAll('.lp-oferta [data-buy]');
      for (var b = 0; b < btns.length; b++) {
        btns[b].addEventListener('click', function (e) {
          var btn = e.currentTarget;
          if (btn.disabled) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var vid = btn.getAttribute('data-variant');
          var addUrl = btn.getAttribute('data-add') || '/cart/add';
          var clearUrl = btn.getAttribute('data-clear') || '/cart/clear';
          if (!vid) { window.location.href = '/checkout'; return; }
          btn.style.opacity = '0.85'; btn.style.pointerEvents = 'none';
          var go = function () { window.location.href = '/checkout'; };
          fetch(clearUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
            .then(function () { return fetch(addUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: vid, quantity: 1 }) }); })
            .then(go).catch(go);
        }, true);
      }
    }
    function init() { initCountdowns(); initReviews(); initScarcity(); initCarousel(); initBuyButtons(); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
    else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-promo-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPromo() {
      var modal = document.getElementById('lpPromoModal');
      if (!modal || modal.dataset.init) return;
      modal.dataset.init = '1';

      var delay = parseInt(modal.getAttribute('data-delay'), 10) || 0;
      var key = 'lp_promo_' + (modal.getAttribute('data-key') || 'default');
      function open() { modal.classList.add('promo-modal--open'); }
      function close() { modal.classList.remove('promo-modal--open'); }

      if (!sessionStorage.getItem(key)) {
        setTimeout(function () { open(); sessionStorage.setItem(key, '1'); }, delay * 1000);
      }

      var closeBtn = modal.querySelector('.promo-modal-close');
      if (closeBtn) closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });

      var copyBtn = modal.querySelector('.promo-btn');
      var codeEl = modal.querySelector('#promoCodeTxt');
      var success = modal.querySelector('.promo-copy-success');
      if (copyBtn && codeEl) {
        copyBtn.addEventListener('click', function () {
          var code = (codeEl.textContent || '').trim();
          var done = function () { if (success) success.hidden = false; };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = code; document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); } catch (e) {}
            document.body.removeChild(ta); done();
          }
        });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPromo);
    } else {
      initPromo();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-testimonios-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousels() {
      var carousels = document.querySelectorAll('.tm-carousel');
      for (var c = 0; c < carousels.length; c++) {
        (function (car) {
          if (car.dataset.init) return;
          car.dataset.init = '1';

          var vp = car.querySelector('.tm-viewport');
          var prev = car.querySelector('.tm-prev');
          var next = car.querySelector('.tm-next');
          if (!vp) return;

          function step() {
            var card = car.querySelector('.tm-card');
            return card ? (card.offsetWidth + 20) : 320;
          }
          function atEnd() { return vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 6; }
          function goNext() {
            if (atEnd()) { vp.scrollTo({ left: 0, behavior: 'smooth' }); }
            else { vp.scrollBy({ left: step(), behavior: 'smooth' }); }
          }
          function goPrev() {
            if (vp.scrollLeft <= 6) { vp.scrollTo({ left: vp.scrollWidth, behavior: 'smooth' }); }
            else { vp.scrollBy({ left: -step(), behavior: 'smooth' }); }
          }

          if (next) next.addEventListener('click', function () { goNext(); resetAuto(); });
          if (prev) prev.addEventListener('click', function () { goPrev(); resetAuto(); });

          // Arrastre con el mouse (en touch se usa el scroll nativo)
          var down = false, startX = 0, startScroll = 0, moved = false;
          vp.addEventListener('pointerdown', function (e) {
            if (e.pointerType !== 'mouse') return;
            down = true; moved = false; startX = e.clientX; startScroll = vp.scrollLeft;
            vp.style.cursor = 'grabbing';
            try { vp.setPointerCapture(e.pointerId); } catch (err) {}
          });
          vp.addEventListener('pointermove', function (e) {
            if (!down) return;
            var dx = e.clientX - startX;
            if (Math.abs(dx) > 3) moved = true;
            vp.scrollLeft = startScroll - dx;
          });
          function endDrag() { if (!down) return; down = false; vp.style.cursor = 'grab'; resetAuto(); }
          vp.addEventListener('pointerup', endDrag);
          vp.addEventListener('pointercancel', endDrag);
          vp.addEventListener('pointerleave', endDrag);
          // evitar "click fantasma" al soltar un arrastre
          vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

          // Auto-avance
          var auto = car.getAttribute('data-auto') === 'true';
          var interval = (parseInt(car.getAttribute('data-interval'), 10) || 4) * 1000;
          var timer = null;
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          function startAuto() { if (!auto || reduce || timer) return; timer = setInterval(goNext, interval); }
          function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
          function resetAuto() { stopAuto(); startAuto(); }

          car.addEventListener('pointerenter', stopAuto);
          car.addEventListener('pointerleave', startAuto);
          car.addEventListener('focusin', stopAuto);
          car.addEventListener('focusout', startAuto);

          startAuto();
        })(carousels[c]);
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initCarousels); }
    else { initCarousels(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-video-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideoTablets() {
      var tablets = document.querySelectorAll('.lp-video-tablet');
      for (var i = 0; i < tablets.length; i++) {
        (function (tablet) {
          if (tablet.dataset.lpInit) return;
          tablet.dataset.lpInit = '1';

          var video = tablet.querySelector('.lp-video-el');
          if (video) {
            var p = video.play();
            if (p && p.catch) {
              p.catch(function () {
                var resume = function () {
                  video.play();
                  ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.removeEventListener(ev, resume); });
                };
                ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, resume, { once: true }); });
              });
            }
          }

          if (tablet.getAttribute('data-hearts') === 'true') {
            setInterval(function () {
              var heart = document.createElement('div');
              heart.className = 'lp-floating-heart';
              var drift = (Math.random() - 0.5) * 60;
              heart.style.setProperty('--drift', drift + 'px');
              heart.style.left = 'calc(50% + ' + ((Math.random() - 0.5) * 120) + 'px)';
              var dur = 2.5 + Math.random() * 2;
              heart.style.animation = 'lp-float-up ' + dur + 's ease-in forwards';
              tablet.appendChild(heart);
              setTimeout(function () { heart.remove(); }, dur * 1000);
            }, 450);
          }
        })(tablets[i]);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoTablets);
    } else {
      initVideoTablets();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
